import React from 'react';

export default function CompletedTransactionIcon() {
  return (
    <svg
      width="15"
      height="18"
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.82731e-06 0.533339C-0.00142481 0.27168 0.22249 0.0272823 0.488642 1.44783e-06H8C8.14292 -0.00033191 8.28511 0.0569161 8.38636 0.155561L11.8409 3.53334C11.9418 3.63233 12.0003 3.77136 12 3.91112V9.10002C11.6769 9.03443 11.3425 9 11 9C10.8312 9 10.6644 9.00836 10.5 9.02469V4.42821H8.10904C7.56064 4.42821 7.26521 3.68626 7.26518 3.40701V1.56274L1.49999 1.56684V14.4333H6.01852C6.06597 14.9862 6.20338 15.5133 6.41604 16H0.545461C0.259867 16 3.19182e-05 15.7459 6.82731e-06 15.4667V0.533339ZM3.51156 11.0001H6.99959C6.66353 11.4475 6.40078 11.9531 6.22918 12.4991H3.56771C3.28549 12.5196 3.01533 12.1811 3.00063 11.7886C2.98593 11.3962 3.22934 11.0205 3.51156 11.0001ZM10.142 3.37778L8.54545 1.81667V3.37778H10.142ZM3.00063 8.78863C3.01533 9.18108 3.28549 9.51956 3.56771 9.49913H8.4538C8.7384 9.50437 9 9.1454 9 8.74961C9 8.35379 8.7384 7.99481 8.4538 8.00006H3.51156C3.22934 8.02055 2.98593 8.39618 3.00063 8.78863ZM3.56771 6.49912C3.28549 6.51956 3.01533 6.18108 3.00063 5.78863C2.98593 5.39618 3.22934 5.02055 3.51156 5.00006H8.4538C8.7384 4.99481 9 5.35378 9 5.74961C9 6.1454 8.7384 6.50437 8.4538 6.49912H3.56771ZM11 10C8.792 10 7 11.792 7 14C7 16.208 8.792 18 11 18C13.208 18 15 16.208 15 14C15 11.792 13.208 10 11 10ZM10.2 16L8.2 14L8.764 13.436L10.2 14.868L13.236 11.832L13.8 12.4L10.2 16Z"
        fill="#445261"
      />
    </svg>
  );
}
